// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"555d8551","899":"d4ffba8d"}[chunkId] + ".chunk.css";
};